// extracted by mini-css-extract-plugin
export default {"closeButton":"modalSeeAllRuns_closeButton__IMw9a","label":"modalSeeAllRuns_label__JfYOm","disgardRunsList":"modalSeeAllRuns_disgardRunsList__nzRXq"};